export default "__VITE_ASSET__c7575146__"